<p-paginator #p [rows]="itemsPerPage" [totalRecords]="totalElements" [rowsPerPageOptions]="rowsPerPageOptions"
    (onPageChange)="emitPageChange($event)"></p-paginator>